// Svelte attachment modeled on Unpoly's `up-expand`: makes an entire container act as if it
// were its single link/button, without wrapping the whole thing in an <a>. The real
// interactive element stays a normal, individually focusable link (better for screen
// readers than one giant card-wide link), while clicking anywhere else in the container
// forwards the click to it. Deliberately no-ops when a container holds more than one
// link/button, since there'd be no unambiguous target to forward to.
export function expandClick(node: HTMLElement) {
  function target() {
    const targets = node.querySelectorAll('a[href], button')
    return targets.length === 1 ? (targets[0] as HTMLAnchorElement | HTMLButtonElement) : null
  }

  function isOwnClick(event: MouseEvent) {
    return (event.target as HTMLElement).closest('a, button') !== null
  }

  function handleClick(event: MouseEvent) {
    if (isOwnClick(event)) return

    const link = target()
    if (!link) return

    if ('href' in link && (event.ctrlKey || event.metaKey || event.shiftKey)) {
      window.open(link.href, '_blank')
      return
    }

    link.click()
  }

  function handleAuxClick(event: MouseEvent) {
    if (event.button !== 1 || isOwnClick(event)) return

    const link = target()
    if (link && 'href' in link) window.open(link.href, '_blank')
  }

  node.addEventListener('click', handleClick)
  node.addEventListener('auxclick', handleAuxClick)

  return () => {
    node.removeEventListener('click', handleClick)
    node.removeEventListener('auxclick', handleAuxClick)
  }
}
